import PropTypes from 'prop-types';
import React from 'react';
import { List, Typography, Box } from '@mui/material';
import { hasAnyPermission } from 'utils/permissions';
import { useSelector } from 'react-redux';
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

const NavGroup = ({ item }) => {
  const authorities = useSelector((state) => state.session.user.authorities);

  const items = item.children?.map((menu) => {
    const menuPermission = hasAnyPermission(authorities, menu.permissions);
    switch (menu.type) {
      case 'collapse':
        return menuPermission ? <NavCollapse key={menu.id} menu={menu} level={1} /> : null;
      case 'item':
        return menuPermission ? <NavItem key={menu.id} item={menu} level={1} /> : null;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });
  return (
    <List
      subheader={
        item.title && (
          <Box sx={{ marginBottom: '2.5rem' }}>
            <Typography variant="subtitle2">{item.title}</Typography>
          </Box>
        )
      }
    >
      {items}
    </List>
  );
};

NavGroup.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.node),
  }).isRequired,
};

export default NavGroup;
